export class ApiClientError extends Error {
  status: number;
  error?: ApiErrorResponse;

  constructor(status: number, error?: ApiErrorResponse) {
    super(error?.message);
    this.status = status;
    this.error = error;
  }
}
